import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeposit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.69998 9.16645V6.38867H3.60106H2.73221H0.0888672L0.0888672 9.16645H2.73221H3.69998Z",
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0889 16.1111V12.2222H12.3111V16.1111H10.0889L13.7 20L17.3111 16.1111L15.0889 16.1111Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2 15.0276V11.1111H12.0007H12.8014H14.4028H16.2V15.0276H20.4437V0H13.6588H6.87383H0.0888672V5.55556H2.27247H4.46192V10H2.27247H0.0888672V15.0276H6.87383H10.9775H11.2Z",
			fill: "#85A0AD"
		})
	]
});
export default SvgDeposit;
